import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React__default, { forwardRef } from 'react';
import Slot from '../../layout/slot/slot.esm.js';

var _excluded = ["anchorClassName"];
var CardSlot = /*#__PURE__*/forwardRef(function CardSlot(props, ref) {
  var _props$anchorClassNam = props.anchorClassName,
    anchorClassName = _props$anchorClassNam === void 0 ? 'csg-tw-card-slot' : _props$anchorClassNam,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React__default.createElement(Slot, _extends({
    ref: ref,
    anchorClassName: anchorClassName
  }, rest));
});
CardSlot.displayName = 'Card.Slot';
var CardSlot$1 = CardSlot;

export { CardSlot$1 as default };
//# sourceMappingURL=card-slot.esm.js.map
